import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiVersionsService } from '../../../../services/versions/api/api-versions.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-version-edit-modal',
  templateUrl: './version-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class VersionEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  versionId: number = 0;
  apiVersion: string = '';
  minAppVersion: string = '';
  gameServerVersion: string = '';
  isActive: boolean = false;

  private callbackSaved?: () => void;

  constructor(private apiVersionsService: ApiVersionsService, private alertsService: AlertsService) {}

  show(versionId: number, apiVersion: string, minAppVersion: string, gameServerVersion: string, isActive: boolean, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.versionId = versionId;
    this.apiVersion = apiVersion;
    this.minAppVersion = minAppVersion;
    this.gameServerVersion = gameServerVersion;
    this.isActive = isActive;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiVersionsService.editVersion(this.versionId, this.apiVersion, this.minAppVersion, this.gameServerVersion, this.isActive).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Version updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating version : ' + error);
      }
    );
  }
}
